<template>
  <v-card flat>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row class="no-gutters pb-5">
        <v-col cols="12" sm="6" md="6" lg="7" :md="$canRoute('internal-transfer-reg-tab') !== 1 ? 12 : 12" :lg="$canRoute('internal-transfer-reg-tab') !== 1 ? 9 : 7">
          <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search anything here ..." single-line solo
            hide-details></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="3" :md="$canRoute('internal-transfer-reg-tab') !== 1 ? 12 : 9" :lg="$canRoute('internal-transfer-reg-tab') !== 1 ? 3 : 3">
          <v-dialog ref="dialog" v-model="modal" :return-value.sync="dateRange" width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="selectedDatesText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down"
                readonly v-bind="attrs" v-on="on" solo class="custom-select" label="Date Range"></v-text-field>
            </template>
            <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
              <v-spacer></v-spacer>
              <v-btn text @click="cancelSelection">Cancel</v-btn>
              <v-btn text @click="confirmSelection">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2" v-if="$canRoute('internal-transfer-reg-tab') === 1">
          <ul>
            <li>
              <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogDeposit"
                content-class="deposit-withdraw-popup marketingPopup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile elevation="0" class="text-capitalize" color="#039de9" v-bind="attrs" v-on="on">
                    <v-icon> mdi mdi-autorenew </v-icon>
                    Transfer
                  </v-btn>
                </template>
                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Internal Transfer
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    Transfer Money From Here
                  </v-card-subtitle>
                  <v-card class="deposit-form px-3 py-4"
                    :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                    <v-row>
                      <v-col cols="12">
                        <fieldset>
                          <legend>From Trading Account</legend>
                          <v-select v-model="from_trading_account_no" solo :items="fromAccountOptions" item-text="text"
                            item-value="value" append-icon="mdi-chevron-down" label="Click to Select"
                            class="custom-select" hide-details @change="updateCurrencyName"></v-select>
                        </fieldset>
                        <span v-if="error.fromAccountError" class="error-message">
                          {{ error.fromAccountError }}
                        </span>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>To Trading Account</legend>
                          <v-select v-model="to_trading_account_no" solo :items="toAccountOptions" item-text="text"
                            item-value="value" append-icon="mdi-chevron-down" label="Select Your Acc."
                            class="custom-select" hide-details></v-select>
                        </fieldset>
                        <span v-if="error.toAccountError" class="error-message">
                          {{ error.toAccountError }}
                        </span>
                      </v-col>
                      <v-col cols="12" :cols="currency.name !== 'USD' ? 6 : 12">
                        <fieldset>
                          <legend>Amount*</legend>
                          <v-text-field v-model="amount" label="USD" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="error.amount_error" class="error-message">
                          {{ error.amount_error }}
                        </span>
                      </v-col>
                      <v-col cols="6" v-if="currency.name !== 'USD'">
                        <fieldset>
                          <legend>Amount in <span :style="{color:currency.color}">({{ currency.name }})</span></legend>
                          <v-text-field disabled :value="amount * currency.rate" label="Enter Amount" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="12">
                        <v-btn tile @click="submitForm" :loading="loading" :disabled ="loading" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
                          color="greenMain">Confirm</v-btn>
                        <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
                          class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
      <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
        <v-data-table :headers="headers" :items-per-page="5" :items="clientinttrxs" :search="search">
          <template v-slot:item.created_at="{ item }">
            {{ formatDate(item?.created_at) }}
          </template>
        </v-data-table>
      </v-sheet>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  REGISTERUSERDETAILS__ACTIONS
} from "@/store/action-types";

export default {
  data() {
    return {
      loading:false,
      headers: [
        { text: "Date and Time", align: "start", value: "created_at" },
        { text: "Name", value: "account_fullname" },
        { text: "Email", value: "account_email" },
        { text: "From Account", value: "from_account" },
        { text: "To Account", value: "trading_account_no" },
        { text: "Amount", value: "amount" },
      ],
      currency:{
        name: 'USD',
        rate: 1,
        color: '#fff'
      },
      dateRange:{},
      error: {
        fromAccountError: null,
        toAccountError: null,
        amount_error: null,
        code_error: null,
      },
      search: "",
      selectedDates: [],
      selectedDatesText: null,
      modal: false,
      dialogDeposit: false,
      from_trading_account_no: null,
      to_trading_account_no: null,
      amount: null,
      client_account_id: null
    };
  },

  computed: {
    ...mapState("reguserdetails", ["clientinttrxs", "tradingAcc"]),
    ...mapState("admins", ["loggedAdmin"]),

    selectedDatesText() {
      return this.dateRange.join(' ~ ');
    },

    fromAccountOptions() {
      return this.tradingAcc.filter(acc => acc.value !== this.to_trading_account_no);
    },
    toAccountOptions() {
      return this.tradingAcc.filter(acc => acc.value !== this.from_trading_account_no);
    }
  },

  methods: {
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.CLIENTINTTRXS, REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS, REGISTERUSERDETAILS__ACTIONS.CREATECLIENTINTX]),

    updateCurrencyName(selectedAccount) {
      const account = this.tradingAcc.find(acc => acc.value === selectedAccount);
      this.currency.name = account ? account.currency_name : 'USD';
      this.currency.rate = account ? account.currency_rate : 1;
      this.currency.color = account ? account.currency_color : '#fff';
    },
    
    async submitForm() {
        this.loading = true;
        if (!this.from_trading_account_no) {
          this.error.fromAccountError = "Select from account";
          return;
        } else {
          this.error.fromAccountError = null;
        }

        if (!this.to_trading_account_no) {
          this.error.toAccountError = "Select to account";
          return;
        } else {
          this.error.toAccountError = null;
        }
        try{
          const formData = {
            client_account_id: this.client_account_id,
            from_trading_account_no: this.from_trading_account_no,
            to_trading_account_no: this.to_trading_account_no,
            amount: this.amount
          };
          await this[REGISTERUSERDETAILS__ACTIONS.CREATECLIENTINTX](formData)
          this.from_trading_account_no = null;
          this.to_trading_account_no = null;
          this.amount = '';
        }catch(error){
          console.log(error)
        }finally{
          this.loading = false;
          this.dialogDeposit = false;
        }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('en-GB');
    },

    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },

    cancelSelection() {
      this.modal = false;
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        console.error("Both start and end dates must be selected");
        return;
      }

      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }

      const parameter = {
        client_account_id: this.client_account_id,
        duration: `${startDate.toISOString().split("T")[0]}to${endDate.toISOString().split("T")[0]
          }`,
      };

      this[REGISTERUSERDETAILS__ACTIONS.CLIENTINTTRXS](parameter);

      this.modal = false;
      this.selectedDates = [startDate, endDate];
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },
  },

  async mounted() {
    this.client_account_id = this.$route.params.id;
    this[REGISTERUSERDETAILS__ACTIONS.CLIENTINTTRXS]({ client_account_id: this.$route.params.id });
    this[REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS](this.$route.params.id);
    this.selectedDatesText = [
      this.getCurrentDate(),
      this.getCurrentDate(),
    ].join(" ~ ");
  },
};
</script>

<style scoped>
.error-message{
  color: #FF567F;
  font-size: 13px;
}
</style>